import type { StripePaymentIntentWithProducts } from '@dr-pam/common-components/Models/Payment';

export const SESSION_STORAGE_FORM = 'signup.form';
export const SESSION_STORAGE_PAYMENT = 'signup.payment';
export const SESSION_STORAGE_SELECTED_SUB = 'signup.selectedSubscriptionType';

export const SESSION_STORAGE_CHECKOUT_READY = 'signup.checkoutReady';
export const SESSION_STORAGE_TS = 'signup.checkoutTs';

// Upgrade engagement storage key
export const STORAGE_KEY_UPGRADE_ENGAGEMENT_ID = 'upgradeEngagementId';

// Upgrade prompt tracking keys
export const STORAGE_KEY_PROMPT_DISMISSED = 'upgrade_prompt_dismissed_';
export const STORAGE_KEY_PROMPT_ENGAGED = 'upgrade_prompt_engaged_';
export const STORAGE_KEY_PROMPT_SHOWN = 'upgrade_prompt_shown_';

// Upgrade session tracking
export const STORAGE_KEY_UPGRADE_SESSION_ID = 'upgrade_session_id';

export function clearSignupState() {
	try {
		sessionStorage.removeItem(SESSION_STORAGE_FORM);
		sessionStorage.removeItem(SESSION_STORAGE_PAYMENT);
		sessionStorage.removeItem(SESSION_STORAGE_SELECTED_SUB);
		sessionStorage.removeItem(SESSION_STORAGE_CHECKOUT_READY);
		sessionStorage.removeItem(SESSION_STORAGE_TS);
	} catch {}
}

/** The payment ID of the checkout this tab has stored, or null when none or unreadable. */
export function storedCheckoutPaymentId(): string | null {
	try {
		const raw = sessionStorage.getItem(SESSION_STORAGE_PAYMENT);
		const id: unknown = raw ? JSON.parse(raw)?.payment?.id : null;
		return typeof id === 'string' && id ? id : null;
	} catch {
		return null;
	}
}

/**
 * Clears the stored checkout once its payment has succeeded. Stripe redirects to the
 * complete page before the checkout can clean up, so otherwise browser Back restores the
 * spent intent into a checkout Stripe refuses to load. A different checkout stored by
 * this tab since is left alone.
 */
export function clearCompletedCheckoutState(intent: Pick<StripePaymentIntentWithProducts, 'status' | 'paymentId'>) {
	if (intent.status === 'SUCCEEDED' && intent.paymentId && storedCheckoutPaymentId() === intent.paymentId) {
		clearSignupState();
	}
}

export function markCheckoutReady() {
	try {
		sessionStorage.setItem(SESSION_STORAGE_CHECKOUT_READY, '1');
		sessionStorage.setItem(SESSION_STORAGE_TS, String(Date.now()));
	} catch {}
}

export function isCheckoutReady(maxAgeMs = 10 * 60 * 1000) {
	try {
		const ready = sessionStorage.getItem(SESSION_STORAGE_CHECKOUT_READY) === '1';
		const hasForm = !!sessionStorage.getItem(SESSION_STORAGE_FORM);
		const hasPayment = !!sessionStorage.getItem(SESSION_STORAGE_PAYMENT);
		const hasSel = !!sessionStorage.getItem(SESSION_STORAGE_SELECTED_SUB);
		const ts = Number(sessionStorage.getItem(SESSION_STORAGE_TS) || 0);
		const fresh = ts > 0 && Date.now() - ts <= maxAgeMs;

		return ready && hasPayment && hasSel && hasForm && fresh;
	} catch {
		return false;
	}
}
